import { FormGroup, UntypedFormGroup } from '@angular/forms';

// custom validator to check that two fields match
export function MinimumUpperCaseCheck(controlName: any, limit: any):any{
    return (formGroup: UntypedFormGroup) => {
        if (!formGroup.controls) return;
        const control = formGroup.controls[controlName];

        if (control.errors) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (countSpecialCharacter(control.value) < limit) {
            control.setErrors({ uppercaseCharacterCheck: true });
        } else {
            control.setErrors(null);
        }
    };
}

function countSpecialCharacter(str: any): any{
    const punct = /[A-Z]/;
    let count = 0;
    for (let i = 0; i < str.length; i++){
        if (!punct.test(str[i])){
            continue;
        }
        count++;
    }
    return count;
}

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors.confirmedValidator
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }